'use strict';

var useButtonStyles = (function () {
  return {
    getButtonColor: function getButtonColor(color, version) {
      if (color === 'error') {
        return 'primary';
      } else if (version === 'v2') {
        if (color === 'primary') {
          return 'secondary';
        } else if (color === 'secondary') {
          return 'primary';
        }
      }

      return color;
    }
  };
});

module.exports = useButtonStyles;
